import {LuImageOff} from 'react-icons/lu';
import Link from 'next/link';

import type {LinkListSelectionFragment} from '@/components/content-blocks/link-list-selection/query';
import ImageFill from '@/modules/foundation/components/image/ImageFill';
import {Heading} from '@/modules/foundation/components/typography/heading';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import {linkFragmentToHref} from '@/modules/foundation/sanity/link/query';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = {
	className?: string;
	linkItem: NonNullable<LinkListSelectionFragment['linkItems']>[number];
	forceAspectRatio?: string;
	headingLevel?: 2 | 3;
};

export const LinkCard = ({className, linkItem, forceAspectRatio, headingLevel}: Props) => {
	const image = linkItem.image?.asset?._ref ? imageWebFromImageWebSchema(linkItem.image) : null;
	return (
		<Link
			href={linkItem.link ? linkFragmentToHref(linkItem.link) : '#'}
			{...(linkItem.link.targetBlank ? {target: '_blank'} : {})}
			className={cn(
				'flex',
				'flex-col',
				'items-stretch',
				'bg-white',
				'overflow-hidden',
				'shadow-[0px_3px_3px_-3px_rgba(0,_0,_0,_0.1),_0px_1px_5px_rgba(0,_0,_0,_0.15)]',
				'hover:shadow-[0px_3px_3px_-2px_rgba(0,_0,_0,_0.16),_0px_0px_5px_2px_rgba(0,_0,_0,_0.08)]',
				className,
			)}
		>
			<div
				className={cn(
					'relative',
					'grid',
					'place-items-center',
					forceAspectRatio ? '' : 'aspect-square sm:aspect-[16/9]',
				)}
				style={{aspectRatio: forceAspectRatio ?? ''}}
			>
				{image ? (
					<ImageFill
						src={image?.image.src}
						width={image.image.width}
						height={image.image.height}
						hotspot={image.image.hotspot}
						alt={linkItem.image?.altText ?? ''}
					/>
				) : (
					<LuImageOff
						aria-hidden
						className={cn('text-dypgronn-industri', 'text-[3rem]')}
					/>
				)}
			</div>
			<div className={cn('grow', 'my-4', 'md:my-6', 'mx-4')}>
				{linkItem.title && (
					<Heading
						level={headingLevel}
						className={cn('text-base!', 'text-dypgronn-industri')}
					>
						{linkItem.title}
					</Heading>
				)}
				{linkItem.intro && <Paragraph>{linkItem.intro}</Paragraph>}
			</div>
		</Link>
	);
};
